import { FolderPrimaryListDto } from "@common/dto/folder/primary-list-dto";
import { MessageConfirmParams } from "@common/hooks/message";
import { FieldListDto } from "@common/dto/field/list-dto";
import { QuestionnaireSubfieldUpdateDto } from "@common/dto/questionnaire/field/subfield-update-dto";
import { QuestionnaireFieldAddDto } from "@common/dto/questionnaire/field/add-dto";
import { QuestionnaireFieldUpdateDto } from "@common/dto/questionnaire/field/update-dto";
import { QuestionnaireFieldListDto } from "@common/dto/questionnaire/field/list-dto";
import { FieldError } from "../../../field";

export enum FieldProperty {
  name = 'name',
  required = 'required',
}

export type FieldProps = {
  errors?: Array<FieldError>;
  editableProperties?: Array<FieldProperty>;
  scrollParentToTop: () => void;
  onGoBack: () => void;
  showConfirmMessage?: (props: MessageConfirmParams) => void;
  data: QuestionnaireFieldUpdateDto | QuestionnaireSubfieldUpdateDto | QuestionnaireFieldAddDto | QuestionnaireFieldListDto;
  onChange: (data: QuestionnaireFieldUpdateDto | QuestionnaireSubfieldUpdateDto | QuestionnaireFieldAddDto) => void;
  getFoldersForSkipLogic: () => Promise<Array<FolderPrimaryListDto>>;
  getFieldsForSkipLogic: (payload: { folderId?: number; system?: boolean; searchQuery?: string }) => Promise<FieldListDto[]>;
};